import { defineMessages } from "react-intl";

export default defineMessages({
    tooltip: {
        id: "components.floatActionButton.tooltip",
        defaultMessage: "Feedback",
    },
});
